import { createSlice } from "@reduxjs/toolkit";

const practitionerSlice = createSlice({
  name: "practitioner",
  initialState: {
    createPractitioner: {},
    createPractitionerLoading: false,
    createPractitionerError: null,
    getPractitioner: {},
    getPractitionerLoading: false,
    getPractitionerError: null,
  },
  reducers: {
    startCreatePractitioner: (state) => {
      state.createPractitionerLoading = true;
      state.createPractitionerError = null;
    },
    successCreatePractitioner: (state, action) => {
      state.createPractitioner = action.payload;
      state.createPractitionerLoading = false;
      state.createPractitionerError = null;
    },
    errorCreatePractitioner: (state, action) => {
      state.createPractitionerLoading = false;
      state.createPractitionerError = action.payload;
    },
    startGetPractitioner: (state) => {
      state.getPractitionerLoading = true;
      state.getPractitionerError = null;
    },
    successGetPractitioner: (state, action) => {
      state.getPractitioner = action.payload;
      state.getPractitionerLoading = false;
      state.getPractitionerError = null;
    },
    errorGetPractitioner: (state, action) => {
      state.getPractitionerLoading = false;
      state.getPractitionerError = action.payload;
    },
  },
});

export const {
  startCreatePractitioner,
  successCreatePractitioner,
  errorCreatePractitioner,
  startGetPractitioner,
  successGetPractitioner,
  errorGetPractitioner,
} = practitionerSlice.actions;

export default practitionerSlice.reducer;